module.exports = __webpack_public_path__ + "static/20180718_114807_optimized-f3d8012ad8c979856ecd2496564af386.jpg";